<app-layout-container>
  <section class="about-hero">
    <app-section-heading [animateTitle]="true"
                         animateTitleTrigger="in-view"
                         eyebrow="About Us"
                         title="A professional, thoughtful approach to team experiences"
                         text="United Team Building is focused on creating experiences and support flows that feel organized, approachable, and meaningful from the first interaction through delivery.">
    </app-section-heading>
  </section>
</app-layout-container>

<app-layout-container>
  <section class="about-story">
    <div class="about-story__grid">
      <div>
        <app-section-heading [animateTitle]="true"
                             animateTitleTrigger="in-view"
                             eyebrow="Our approach"
                             title="Clear communication, strong planning, and client-friendly execution"
                             text="The goal is not only to provide a strong event or service outcome, but also to make the process FUN and the desire for the client to engage with their team.">
        </app-section-heading>
      </div>

      <div class="about-story__panel">
        <p>
          United Team Building is designed around the idea that team experiences should feel polished,
          coordinated, and welcoming.
        </p>
        <p>
          Whether the need is a corporate team event, onboarding support, or a structured intake process,
          the experience should be simple, professional, and aligned to the client’s goals.
        </p>
      </div>
    </div>
  </section>
</app-layout-container>

<app-layout-container>
  <section class="about-values">
    <app-section-heading [animateTitle]="true"
                         animateTitleTrigger="in-view"
                         eyebrow="What matters"
                         title="Core principles behind the experience"
                         text="The foundation of the site and service model is built around a few clear principles.">
    </app-section-heading>

    <div class="about-values__grid">
      <article class="value-card">
        <h3>Fun</h3>
        <p>Make every step enjoyable, engaging, and memorable.</p>
      </article>

      <article class="value-card">
        <h3>Professionalism</h3>
        <p>Present a polished experience that builds trust from the start.</p>
      </article>

      <article class="value-card">
        <h3>Engagement</h3>
        <p>Create experiences that help people connect more meaningfully.</p>
      </article>
    </div>
  </section>
</app-layout-container>

<app-layout-container>
  <section class="about-bottom-cta">
    <app-cta-banner [animateTitle]="true"
                    animateTitleTrigger="in-view"
                    eyebrow="Want to connect?"
                    title="Let’s talk about your team, goals, and next step"
                    text="If you’re planning a team experience or need onboarding support, we’d love to hear more."
                    primaryLabel="Contact Us"
                    primaryLink="/contact-us"
                    secondaryLabel="Explore Services"
                    secondaryLink="/services">
    </app-cta-banner>
  </section>
</app-layout-container>
